var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('CustomContainer', {
    attrs: {
      "customClass": "transfer-design--wrapper content modal-scroll-area",
      "elementType": "section"
    }
  }, [_c('CustomText', {
    attrs: {
      "customClass": "transfer-design--description",
      "keyTranslation": "transferDesignModalDescription"
    }
  }), _c('CustomContainer', {
    attrs: {
      "customClass": ['transfer-design--options-scroll', {
        'scroll-activated': _vm.isOverMaxLength
      }]
    }
  }, [_c('CustomContainer', {
    attrs: {
      "customClass": "transfer-design--options"
    }
  }, _vm._l(_vm.recipes, function (recipeData, modelName) {
    return _c('CustomContainer', {
      key: modelName,
      attrs: {
        "customClass": ['transfer-design--option', {
          'selected': _vm.isSelected(modelName)
        }]
      },
      on: {
        "click": function click($event) {
          return _vm.onSelect(modelName, recipeData);
        }
      }
    }, [_c('CustomContainer', {
      style: "background-image: url('".concat(_vm.$store.state.transferDesign.imageUrls[modelName], "')"),
      attrs: {
        "customClass": "transfer-design--image"
      }
    }), _c('CustomContainer', {
      attrs: {
        "customClass": "transfer-design--content"
      }
    }, [_c('CustomText', {
      attrs: {
        "customClass": "transfer-design--name",
        "text": recipeData.displayName
      }
    }), _c('CustomContainer', {
      attrs: {
        "customClass": "transfer-design--price"
      }
    }, [_c('currencyWrapper', {
      attrs: {
        "priceRaw": _vm.prices[modelName]
      }
    })], 1), _c('CustomText', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: recipeData.isPersonalizationInvalid,
        expression: "recipeData.isPersonalizationInvalid"
      }],
      attrs: {
        "customClass": "transfer-design--text",
        "keyTranslation": "transferDesignEmbroideryText"
      }
    })], 1)], 1);
  }), 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }